import defaultConfig from '../../default'
import type { GatewayConfig } from '../../declarations'
import HeaderLogo from './HeaderLogo.svelte'
import ShowcaseIcon from 'images/icon-ribbon.png'
import GalleryIcon from 'images/icon-gallery.png'
import MapIcon from 'images/icon-map.png'
import DatasetIcon from 'images/icon-dataset.png'
import GroupIcon from 'images/icon-group.png'

export default {
  ...defaultConfig,

  gateway: 'waenergy',
  title: window.gettext('Columbia Plateau Least-Conflict Solar Siting Gateway'),
  logoComponent: HeaderLogo,
  footer: [
    { label: window.gettext('About Data Basin'), href: '/about/' },
    { label: window.gettext('Terms of Use'), href: '/pages/terms-service/' },
    { label: window.gettext('Contact Us'), href: '/services/contact/' },
  ],
  pages: {
    ...defaultConfig.pages,
    home: () => import('./Home.svelte'),
  },
  navigation: user => {
    const navigation = defaultConfig.navigation(user)
    return [
      {
        id: 'get-started',
        label: window.gettext('Get Started'),
        items: [
          {
            type: 'text',
            text: window.gettext(
              'Data Basin is a science-based mapping and analysis platform that supports learning, research, and sustainable environmental stewardship.',
            ),
            label: window.gettext('More about Data Basin...'),
            href: '/about/',
          },
          {
            type: 'divider',
          },
          {
            type: 'link',
            label: window.gettext('View Video Tutorials'),
            href: '/videos/',
          },
          {
            type: 'link',
            label: window.gettext('Search Geographies or Keywords'),
            href: '/search/',
          },
          {
            type: 'divider',
          },
          {
            type: 'link',
            label: window.gettext('FAQs'),
            href: '/help/',
            bold: true,
          },
          {
            type: 'link',
            label: window.gettext('Support Services'),
            href: '/services/services/',
            bold: true,
          },
          {
            type: 'link',
            label: window.gettext('Glossary'),
            href: '/glossary/',
            bold: true,
          },
        ],
      },
      {
        id: 'explore',
        label: window.gettext('Explore'),
        items: [
          {
            type: 'link',
            label: window.gettext('Showcase'),
            image: ShowcaseIcon,
            href: '/showcase/',
          },
          {
            type: 'link',
            label: window.gettext('Galleries'),
            image: GalleryIcon,
            href: '/galleries/',
          },
          {
            type: 'link',
            label: window.gettext('Maps'),
            image: MapIcon,
            href: '/maps/',
          },
          {
            type: 'link',
            label: window.gettext('Datasets'),
            image: DatasetIcon,
            href: '/datasets/',
          },
        ],
      },
      {
        id: 'create',
        label: window.gettext('Create'),
        width: '245px',
        items: [
          {
            type: 'link',
            label: window.gettext('Create a Map'),
            image: MapIcon,
            href: '/maps/new/',
          },
          {
            type: 'link',
            label: window.gettext('Import a Dataset'),
            image: DatasetIcon,
            href: '/datasets/import/',
          },
          {
            type: 'link',
            label: window.gettext('Create a Group'),
            image: GroupIcon,
            href: '/groups/new/',
          },
          {
            type: 'link',
            label: window.gettext('Create a Gallery'),
            image: GalleryIcon,
            href: '/galleries/new/',
          },
        ],
      },
      navigation.find(menu => menu.id === 'community'),
    ]
  },
} as GatewayConfig
